import {
  Sekcja,
  Opis,
  Wstep,
  Tytul,
  Haslo,
  Paragraf,
  Przyciski,
  ToolsHint,
  Opinie,
  Ocena,
  Podstawa,
  Gwiazda,
  Przycisk,
  Odnosnik,
  Strzalka,
  PhotoCard,
  Zdjecie,
} from "./styled";
import gwiazdka from "../../../images/gwiazdka.png";
import strzalka from "../../../images/icon-arrow.png";
import heroPhoto from "../../../images/sekcja-1-zdjecie-mobile.png";
import { handleSectionClick } from "../../../scrollToSection";
import { reviewsWebUrl, googleNavigationProps } from "../../../googleMapsLinks";

const StronaTytulowa = () => {
  return (
    <Sekcja>
      <Opis>
        <Wstep>Pośrednictwo kredytowe w Suwałkach • online w całej Polsce</Wstep>
        <Tytul>Kredyt hipoteczny bez chaosu.</Tytul>
        <Haslo>Jasny plan od pierwszej rozmowy do uruchomienia.</Haslo>
         <Paragraf> 
          Kupujesz mieszkanie, budujesz dom albo chcesz przenieść obecny kredyt?
          Porównamy możliwości, uporządkujemy dokumenty i przeprowadzimy Cię przez
          kolejne kroki prostym językiem.
        </Paragraf>

        <Przyciski>
          <Przycisk href="#wybierz-cel" onClick={handleSectionClick("wybierz-cel")}>Zobacz, w czym pomagamy</Przycisk>
          <Odnosnik href="#formularz" data-contact-cta onClick={handleSectionClick("formularz")}>
            Umów rozmowę
            <Strzalka src={strzalka} alt="" aria-hidden="true"></Strzalka>
          </Odnosnik>
        </Przyciski>
        <ToolsHint>Bezpłatnie i bez rejestracji: kalkulatory, checklisty i wzór umowy przedwstępnej.</ToolsHint>
        <Opinie {...googleNavigationProps(reviewsWebUrl)} data-reviews-link aria-label="Otwórz opinie klientów w Google">
          <Ocena>5.0</Ocena>
          <Gwiazda src={gwiazdka} alt="" aria-hidden="true" />
          <Gwiazda src={gwiazdka} alt="" aria-hidden="true" />
          <Gwiazda src={gwiazdka} alt="" aria-hidden="true" />
          <Gwiazda src={gwiazdka} alt="" aria-hidden="true" />
          <Gwiazda src={gwiazdka} alt="" aria-hidden="true" />
        </Opinie>
        <Podstawa>ocena na podstawie opinii Google</Podstawa>
      </Opis>
      <PhotoCard>
        <Zdjecie
          src={heroPhoto}
          alt="Justyna i Paweł Kowalewscy przed biurem Serce Finansów w Suwałkach"
          width="360"
          height="446"
          loading="eager"
          fetchpriority="high"
          decoding="async"
        />
      </PhotoCard>
    </Sekcja>
  );
};

export default StronaTytulowa;

